export function isString(value) {
  return typeof value === "string" || value instanceof String;
}

export function capitalize(key) {
  return key[0].toUpperCase() + key.slice(1).toLowerCase();
}

export function convertCamelCase(phrase) {
  return phrase
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
}

export function lowerCase(key) {
  return key[0].toLowerCase() + key.slice(1);
}

export function upperCase(key) {
  return key[0].toUpperCase() + key.slice(1).toUpperCase();
}

export function numberUnMasking(number) {
  return number
    .replace("(", "")
    .replace(")", "")
    .replace("x", "")
    .replace("-", "")
    .replace(" ", "")
    .trim();
}

export function numberMasking(number) {
  if (number.replace(/[^0-9]/g, "").length <= 3) {
    return number.replace(/[^0-9]/g, "").replace("$1");
  } else if (number.replace(/[^0-9]/g, "").length <= 5) {
    return number.replace(/[^0-9]/g, "").replace(/(\d{3})/, "($1) ");
  } else if (number.replace(/[^0-9]/g, "").length <= 6) {
    return number.replace(/[^0-9]/g, "").replace(/(\d{3})(\d*)/, "($1) $2");
  } else if (number.replace(/[^0-9]/g, "").length <= 10) {
    return number
      .replace(/[^0-9]/g, "")
      .replace(/(\d{3})(\d{3})(\d*)/, "($1) $2-$3");
  } else {
    return number
      .replace(/[^0-9]/g, "")
      .replace(/(\d{3})(\d{3})(\d{4})(\d*)/, "($1) $2-$3x$4");
  }
}

export function addLeadingZero(input) {
  const str = input.toString();
  if (str === "0") {
    return "00";
  }
  return str.replace(/\b(?!0)(\d)\b/g, "0$1");
}

export const isInt = (value) => {
  return Number.isInteger(Number(value));
};

export const isDouble = (value) => {
  return !isNaN(value) && parseFloat(value) === Number(value);
};
